import type { Frame } from "@/api/spaces";

interface StalePosition {
  x: number;
  y: number;
}

const stalePositions = new Map<string, StalePosition>();

export function rememberStaleCanvasTimePagePositions(
  positions: Iterable<{ id: string; x: number; y: number }>,
): void {
  for (const position of positions) {
    stalePositions.set(position.id, { x: position.x, y: position.y });
  }
}

export function clearStaleCanvasTimePagePositions(
  frameIds: Iterable<string>,
): void {
  for (const id of frameIds) stalePositions.delete(id);
}

export function protectCanvasTimePageGeometry<T extends Partial<Frame>>(
  frameId: string,
  update: T,
): T {
  const stale = stalePositions.get(frameId);
  if (!stale) return update;

  const hasX = update.position_x !== undefined;
  const hasY = update.position_y !== undefined;
  if (!hasX && !hasY) return update;
  const matchesStale =
    (!hasX || update.position_x === stale.x) &&
    (!hasY || update.position_y === stale.y);
  if (!matchesStale) {
    stalePositions.delete(frameId);
    return update;
  }

  const next = { ...update };
  delete next.position_x;
  delete next.position_y;
  return next;
}
